export const PRIORITY_COUNTRIES = ['CZE', 'SVK', 'POL', 'DEU', 'AUT'] as const;

type PriorityCountry = (typeof PRIORITY_COUNTRIES)[number];

export function isPriorityCountry(code: string): code is PriorityCountry {
  return PRIORITY_COUNTRIES.includes(code as PriorityCountry);
}
